module.exports = __webpack_public_path__ + "static/media/our-brands-doo-prime.d2bb0900.svg";